import _slicedToArray from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState, useEffect } from 'react';
import { createPortal, unmountComponentAtNode } from 'react-dom';
export var usePortal = function usePortal() {
  var _React$useState = React.useState(function () {
    var el = document.createElement('div');
    return el;
  }),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      container = _React$useState2[0];

  var _useState = useState({
    render: function render() {
      return null;
    },
    remove: function remove() {
      return null;
    }
  }),
      _useState2 = _slicedToArray(_useState, 2),
      portal = _useState2[0],
      setPortal = _useState2[1];

  var ReactCreatePortal = React.useCallback(function (elmm) {
    var Portal = function Portal(_ref) {
      var children = _ref.children;
      if (!children) return null;
      return /*#__PURE__*/createPortal(children, elmm);
    };

    var remove = function remove(elm) {
      elm && unmountComponentAtNode(elm);
    };

    return {
      render: Portal,
      remove: remove
    };
  }, []);
  useEffect(function () {
    if (container) portal.remove();
    var newPortal = ReactCreatePortal(container);
    setPortal(newPortal);
    return function () {
      newPortal.remove(container);
    };
  }, [container]);
  return {
    Portal: portal.render,
    container: container
  };
};